import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@material-ui/core';

interface ActiveCardProps {
  bgColor: string;
  label: string;
  count?: string;
  comparison?: number;
  link?: string;
  isNegative?: boolean;
  showComparison?: boolean;
  selectedLabel?: string;
}

const ActiveCard: React.FC<ActiveCardProps> = ({ bgColor, label, count, link }) => {
  return (
    <ActiveModals bgColor={bgColor}>
      <Link to={link || ''} className="link">
        <Heading>{label}</Heading>
        <Box display={'flex'} alignItems={'baseline'} style={{ gap: '12px' }}>
          <Count>{count}</Count>
        </Box>
      </Link>
    </ActiveModals>
  );
};

export default ActiveCard;

const ActiveModals = styled.div<{ bgColor: string }>`
  background: ${(props) => props.bgColor};
  border: 1px solid ${(props) => props.bgColor};
  border-radius: 10px;
  .link {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 18px 16px;
    color: inherit;
    text-decoration: none;
  }
  .link:hover {
    text-decoration: none;
  }
`;

const Heading = styled.span`
  color: #111111;
  font-size: 13px;
  font-family: Poppins;
  font-weight: 400;
  word-wrap: break-word;
  line-height: 18px;
`;

const Count = styled.p`
  color: #111111;
  font-size: 42px;
  font-family: Poppins;
  font-weight: 500;
  word-wrap: break-word;
  line-height: 18px;
`;
